//
export default [
    {
        text    : "#",
        value   : "id",
    },
    {
        text    : "rut",
        format  : "rut",
        value   : "g_user_hr_employee_rut",
    },
    {
        text    : "solicitante",
        value   : "g_user_hr_employee_full_name",
    },
    {
        text    : "proveedores",
        value   : "pch_providers_alias_names",
        component: {
            type: "chip-list",
            props: {
                disabled: true,
                label: true,
                small: true,
                textColor: "black",
            },
        },
    },
    {
        text    : "items",
        align   : "center",
        value   : "pch_detail_purchase_quotations_length",
    },
    {
        text    : "fecha de creación",
        align   : "right",
        format  : "datetime",
        value   : "created_at",
    },
]